/**
 * Whether the forge page shows Claude Code's tool activity. OFF by default —
 * most users want the conversation, not the tool log — and remembered per
 * browser. Storage can be unavailable (private windows, blocked site data);
 * the toggle then still works for the session.
 */
import { useCallback, useState } from 'react';

export const FORGE_SHOW_TOOL_ACTIVITY_KEY = 'fias.forge.showToolActivity';

function read(): boolean {
  try {
    return window.localStorage.getItem(FORGE_SHOW_TOOL_ACTIVITY_KEY) === 'true';
  } catch {
    return false;
  }
}

export function useForgeShowToolActivity(): [boolean, (show: boolean) => void] {
  const [show, setShow] = useState(read);
  const update = useCallback((next: boolean) => {
    setShow(next);
    try {
      window.localStorage.setItem(FORGE_SHOW_TOOL_ACTIVITY_KEY, String(next));
    } catch {
      // Not persisted; the choice still holds for this page.
    }
  }, []);
  return [show, update];
}
